import React from 'react';
import { motion } from 'framer-motion';

const AppSection = () => {
  const steps = [
    {
      number: "STEP 1",
      title: "Choose Your Service",
      description: "Select the type of service you need, whether it's a chauffeur or a messenger. Customize your request to fit your schedule."
    },
    {
      number: "STEP 2",
      title: "Book Instantly",
      description: "Confirm your booking with a single tap. Our system matches you with the nearest available driver or courier."
    },
    {
      number: "STEP 3",
      title: "Track Your Service",
      description: "Select a professional driver for personal transportation or a courier for fast, secure deliveries. Tailor the service to your schedule and needs with ease. Jacks ensures reliability and flexibility for every booking."
    },
    {
      number: "STEP 4",
      title: "Complete",
      description: "Once your ride is complete, you can rate your experience and provide feedback. Your satisfaction is our priority."
    }
  ];

  return (
    <section id="how-its-work" className="text-white py-20" style={{ backgroundColor: '#131313' }}>
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-16">Steps For Using Jacks</h2>
        
        <div className="flex flex-col lg:flex-row items-start mb-32">
          {/* Image téléphone gauche */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="flex-1"
          >
            <img 
              src="/assets/icons/phone-1.png" 
              alt="Jacks App Interface" 
              className="w-full max-w-md mx-auto"
            />
          </motion.div>

          {/* Liste des étapes avec dégradé en bas */}
          <div className="flex-1 space-y-8 ps-8 overflow-y-auto relative pb-20" style={{ maxHeight: '500px', borderLeft: '4px solid', borderImage: 'linear-gradient(to bottom, white, #131313) 1', scrollbarWidth: 'none', msOverflowStyle: 'none', maskImage: 'linear-gradient(to bottom, white 70%, transparent)' }}>
            {steps.map((step, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
              >
                <span className="text-gray-400 mb-2 block">{step.number}</span>
                <h3 className="text-3xl font-bold mb-4">{step.title}</h3>
                <p className="text-gray-300 mb-6">{step.description}</p>
                {/* <div className="flex items-center gap-3 cursor-pointer group">
                  <span className="text-lg custom-font">Learn More</span>
                  <img 
                    src="/assets/icons/right-arrow-variant.svg" 
                    alt="right arrow" 
                    className="w-15 h-15 transition-transform duration-300 group-hover:translate-x-1"
                  />
                </div> */}
              </motion.div>
            ))}
          </div>
        </div>

        {/* Section App Mobile */}
        <div className="flex flex-col lg:flex-row items-center gap-10">
          {/* Contenu gauche */}
          <div className="flex-1">
            <h2 className="text-4xl font-bold mb-4">Our Mobile App</h2>
            <h3 className="text-2xl mb-6">Available For Android & IOS</h3>
            <p className="text-gray-300 mb-8">
              Use our app to schedule a reservation wherever you are, whenever you want, for a worry-free ride. All it takes is two taps on your iPhone or Android device.
            </p>
            <div className="flex gap-4">
              <motion.a 
                href="https://apps.apple.com/us/app/book-jacks/id6738385560" 
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.05 }}
                className="block"
              >
                <img 
                  src="/assets/icons/appstore-btn.png" 
                  alt="App Store" 
                  className="h-20 object-contain"
                />
              </motion.a>
              <motion.a 
                href="#" 
                rel="noopener noreferrer"
                whileHover={{ scale: 1.05 }}
                className="block"
              >
                <img 
                  src="/assets/icons/playstore-btn.png" 
                  alt="Play Store" 
                  className="h-20 object-contain"
                />
              </motion.a>
            </div>
          </div>

          {/* Image téléphone droite */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="flex-1"
          >
            <img 
              src="/assets/icons/phone-2.png" 
              alt="Jacks App" 
              className="w-full max-w-md mx-auto"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AppSection;